module.exports = __webpack_public_path__ + "img/lk.d8453839.svg";